import React, { useState } from "react";
import {
  Badge,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { Inbox as InboxIcon, ExpandLess, ChevronRight, FiberManualRecord } from "@material-ui/icons";
import { Link } from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Dot from "../Dot";

export default function SidebarLink({
  link,
  icon,
  label,
  children,
  location,
  isSidebarOpened,
  nested,
  type,
  badgeContent,
  parentIcon,
}) {
  var classes = useStyles();

  var isLinkActive =
    link &&
    (location.pathname === link || location.pathname.indexOf(link) !== -1);

  // Highlight + auto-expand a parent when one of its children is the active route.
  var isAnyChildActive =
    Array.isArray(children) &&
    children.some(
      (c) =>
        c &&
        c.link &&
        (location.pathname === c.link || location.pathname.indexOf(c.link) !== -1),
    );

  // local
  var [isOpen, setIsOpen] = useState(Boolean(isAnyChildActive));

  if (type === "title")
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {label}
      </Typography>
    );

  if (type === "divider") return <Divider className={classes.divider} />;
  if (link && link.includes('http')) {
    return (
      <ListItem
        button
        className={classes.link}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        <a className={classes.externalLink} href={link}>
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          {badgeContent ? (
            <Badge
              badgeContent={badgeContent}
              color="secondary"
              overlap="rectangular"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              {icon || (nested ? null : <InboxIcon />)}
            </Badge>
          ) : (
            icon || (nested ? null : <InboxIcon />)
          )}
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={label}
        />
        </a>
      </ListItem>
    )
  }
  if (!children)
    return (
      <ListItem
        button
        component={link && Link}
        to={link}
        className={classes.link}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          {nested ? (
            (icon || parentIcon) ? (
              <span className={classes.nestedIcon}>{icon || parentIcon}</span>
            ) : (
              <FiberManualRecord
                className={classnames(classes.nestedBullet, {
                  [classes.nestedDotActive]: isLinkActive,
                })}
              />
            )
          ) : (
            icon || <InboxIcon />
          )}
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={label}
        />
      </ListItem>
    );

  return (
    <>
      <ListItem
        button
        component={link && Link}
        onClick={toggleCollapse}
        className={classes.link}
        classes={{
          root: classnames({
            [classes.linkActive]: (isLinkActive || isAnyChildActive) && !nested,
          }),
        }}
        to={link}
        disableRipple
      >
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive || isAnyChildActive,
          })}
        >
          {icon ? icon : <InboxIcon />}
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive || isAnyChildActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={label}
        />
        {children && isSidebarOpened && (
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
            {isOpen ? (
              <ExpandLess className={classes.expandIcon} />
            ) : (
              <ChevronRight className={classes.expandIcon} />
            )}
          </div>
        )}
      </ListItem>
      {children && (
        <Collapse
          in={isOpen && isSidebarOpened}
          timeout="auto"
          unmountOnExit
          className={classes.nestedList}
        >
          <List component="div" disablePadding>
            {children.map(childrenLink => (
              <SidebarLink
                key={childrenLink && childrenLink.link}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                nested
                parentIcon={icon}
                {...childrenLink}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );

  // ###########################################################

  function toggleCollapse(e) {
    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  }
}
